export default {"src":"/_next/static/media/law-icon.03e59833.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};